import { render, staticRenderFns } from "./PatientGeneralData.vue?vue&type=template&id=25804842&scoped=true&"
import script from "./PatientGeneralData.vue?vue&type=script&lang=js&"
export * from "./PatientGeneralData.vue?vue&type=script&lang=js&"
import style0 from "./PatientGeneralData.vue?vue&type=style&index=0&id=25804842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25804842",
  null
  
)

export default component.exports